export function getKeys<T extends object>(obj: T) {
  return Object.keys(obj) as (keyof T)[];
}

function reverseFieldNamesMap(obj: Record<string, string | null>) {
  return Object.keys(obj).reduce(
    (acc, key) => {
      const value = obj[key];
      if (value !== null) {
        acc[value] = key;
      }
      return acc;
    },
    {} as Record<string, string>
  );
}

export function renameFields(
  obj: Record<string, any>,
  fieldsToRename: Record<string, string | null>
) {
  /**
   * The fieldsToRename map is reversed because this way we can type them according to the final
   * object types, i.e.
   *
   * const fieldsToRename: Record<keyof TargetComponentLabels, string> = {
   *    glass: "materials-glass",
   * }
   *
   * if a new field is added to TargetComponentLabels, let's say "stone", TypeScript will automatically
   * detect the missing field in fieldsToRename and it will have to be fixed before commit.
   */
  const reversedMap = reverseFieldNamesMap(fieldsToRename);
  return Object.keys(obj).reduce(
    (acc, key) => {
      const renamedKey = reversedMap[key];
      acc[renamedKey ?? key] = obj[key];
      return acc;
    },
    {} as Record<string, any>
  );
}
